import type {
  ViewActionDefs,
  ViewActionArgs,
  ViewAction,
  ExcludeActionType,
} from '../types'

const ViewActionFactory = {
  navigate: ({ items = [] }) => ({
    type: 'submenu',
    label: 'Navigate to',
    actionType: 'navigate',
    items,
  }),
  view: {
    type: 'action',
    label: 'Composer',
    actionType: 'view',
  },
  view_placements: ({ disabled }) => ({
    type: 'action',
    label: 'Placements Previewer',
    actionType: 'view_placements',
    disabled,
  }),
  preview_url: ({ disabled }) => ({
    type: 'action',
    label: 'Preview URL',
    actionType: 'preview_url',
    disabled,
  }),
  toggle_sections: {
    type: 'action',
    label: 'Toggle Sections',
    actionType: 'toggle_sections',
  },
} as const satisfies ViewActionDefs

export const getViewActions = ({
  canToggleSections,
  contentHasPlacements,
  isPresenting,
  placementsEnabled,
  postType,
  previewUrlEnabled,
  userCanEditContent,
}: ViewActionArgs): ViewAction[] => {
  const viewActions: ViewAction[] = []
  const navigateActions: ExcludeActionType<ViewAction, 'navigate'>[] = []

  if (isPresenting && userCanEditContent) {
    navigateActions.push(ViewActionFactory.view)
  }

  if (!isPresenting && contentHasPlacements) {
    navigateActions.push(
      ViewActionFactory.view_placements({ disabled: !placementsEnabled })
    )
  }

  if (postType === 'url_preview') {
    navigateActions.push(
      ViewActionFactory.preview_url({ disabled: !previewUrlEnabled })
    )
  }

  if (navigateActions.length > 0) {
    viewActions.push(ViewActionFactory.navigate({ items: navigateActions }))
  }

  if (canToggleSections) {
    viewActions.push(ViewActionFactory.toggle_sections)
  }

  return viewActions
}
